import { z } from "zod/v4";

export const RechargeGlobalSettingsDtoSchema = z.object({
  singlePurchaseQuerySelectors: z.array(z.string()).default([]),
  singlePurchasePriceQuerySelectors: z.array(z.string()).default([]),
  subscribeAndSaveQuerySelectors: z.array(z.string()).default([]),
  subscribeAndSavePriceQuerySelectors: z.array(z.string()).default([]),
  subscribeAndSavePercentageQuerySelectors: z.array(z.string()).default([]),
  installmentPriceQuerySelectors: z.array(z.string()).default([]),
});

export type RechargeGlobalSettingsDto = z.infer<
  typeof RechargeGlobalSettingsDtoSchema
>;

export const RechargeExperienceSettingsDtoSchema = z.object({
  isSubDefault: z.boolean().nullish(),
  variationSettings: z
    .object({
      variationId: z.uuid(),
      discount: z.number().nullish(),
      preSubscribeText: z.string().nullish(),
      postSubscribeText: z.string().nullish(),
      oneTimeMessage: z.string().nullish(),
    })
    .array(),
});
export type RechargeExperienceSettingsDto = z.infer<
  typeof RechargeExperienceSettingsDtoSchema
>;

export const RechargeWebhookSubTypeList = ["order", "subscription"] as const;

export type RechargeWebhookSubType =
  (typeof RechargeWebhookSubTypeList)[number];

export const RechargeWebhookTopicList = [
  "address/created",
  "address/updated",

  "charge/created",
  "charge/paid",
  "charge/failed",
  "charge/max_retries_reached",
  "charge/upcoming",
  "charge/updated",
  "charge/refunded",

  "customer/created",
  "customer/update",
  "customer/activated",
  "customer/deactivated",
  "customer/payment_method_updated",

  "onetime/created",
  "onetime/updated",
  "onetime/deleted",

  "order/created",
  "order/processed",
  "order/deleted",
  "order/updated",
  "oder/upcoming",

  "subscription/created",
  "subscription/updated",
  "subscription/activated",
  "subscription/cancelled",
  "subscription/deleted",
  "subscription/skipped",
  "subscription/unskipped",
] as const;

export type RechargeWebhookTopic = (typeof RechargeWebhookTopicList)[number];
